export enum GetSellingSpotsActionTypes {
    REQUEST = '@@selling/get-selling-spots/request',
    SUCCESS = '@@selling/get-selling-spots/success',
    ERROR = '@@selling/get-selling-spots/error'
}
